import { render, staticRenderFns } from "./anchor-navigation.vue?vue&type=template&id=8dc0ccaa&scoped=true"
import script from "./anchor-navigation.vue?vue&type=script&lang=js"
export * from "./anchor-navigation.vue?vue&type=script&lang=js"
import style0 from "./anchor-navigation.vue?vue&type=style&index=0&id=8dc0ccaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc0ccaa",
  null
  
)

export default component.exports